
<template>
  <GameDetail v-if="detail !== ''" :detail="detail" :popInKr="true" :notshowback="true" />
  <div v-else-if="detail === ''" class="content-area">
    <div class="page-title" :class="!isPC ? 'm-page-title' : ''" style="color: #fff;">{{currentLang === 'en' ? 'My Innovation My Show” Interactive Experience Area' : '“我创我秀”互动体验展示区'}}</div>
    <div :class="isPC ? 'list-wrapper' : 'm-list-wrapper'">
      <div v-for="item of currentLang === 'en' ? gameListEn : gameList" :key="item.id" :class="isPC ? 'cart-item' : 'm-cart-item'">
        <div class="img-wrapper">
          <img :src="item.imgUrl" alt="">
        </div>
        <div class="info-area">{{item.title}}</div>
        <div class="cart-button activity-button">
          <span @click="showDetail(item)">{{currentLang === 'en' ? 'Enter' : '点击进入'}}</span>
        </div>
      </div>
    </div>
    <div class="button-wrapper" :class="!isPC ? 'm-button-wrapper' : ''">
      <div class="button-item-wrapper">
        <span @click="showDetail({id: 'live005'})" class="button-item bt-1">{{currentLang === 'en' ? 'Rocket Acceleration' : '火箭加速度'}}<span class="bt1-img"></span></span>
      </div>
      <div class="button-item-wrapper">
        <span @click="showDetail({id: 'live006'})" class="button-item bt-2">{{currentLang === 'en' ? 'sharp eyes' : '火眼金睛'}}<span class="bt2-img"></span></span>
      </div>
    </div>
  </div>
</template>

<script>
import GameDetail from '@/components/games/GameDetail'
export default {
  name: 'Game',
  components: { GameDetail },
  props: ['popInKr', 'hotspot'],
  data() {
    return {
      detail: '',
      gameList: [
        {
          id: 'live001',
          title: '走进AI',
          imgUrl: require('../assets/web/game_1.png'),
          detail_button: '报名答题',
          detail_title: '走近AI——AI知识学堂规则',
          detail_content: '每天一道人工智能相关的知识问答，带你走近AI世界！可以在答题页面查看提示，了解相关内容。20天时间，点亮所有拼图，等你来玩哦！',
          detail_url: 'http://ai.secsa.cn'
        }, {
          id: 'live002',
          title: '探秘AI',
          imgUrl: require('../assets/web/game_2.png'),
          detail_button: '开始体验',
          detail_title: '探秘AI',
          detail_content: '腾讯AI体验馆与AI Lab、腾讯优图、微信智聆等腾讯AI实验室进行合作，将前沿的AI技术用最轻量级的体验方式、最易于理解的交互实验展示出来。实验涉及图像、语音、自然语言、机器学习等算法，为k12学生初识人工智能输送经典案例。',
          detail_url: 'https://aiep.qcloud.com/#/aiExperience?iSchoolId=10372&iCloudToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJybHMiOiJzdHVkZW50IiwiYWlkIjoiMTAzNzIiLCJzaWQiOiIxMDAwMSIsInVpbiI6IjhkYVU3IiwiZXhwIjoxNTk3OTM5MjU0LCJpYXQiOjE1OTU0NzY0NTR9.jFMZEt1Q7EDT6AKJKIVjo3KnUSaSx_7npg4ZHFvai0U'
        }, {
          id: 'live003',
          title: 'AI技术大挑战',
          imgUrl: require('../assets/web/game_3.png'),
          detail_button: '报名参加',
          detail_title: '挑战AI—“挑战AI”微视频征集活动规则',
          detail_content: '参赛选手可以寻找我们现实生活中的人工智能产品，也可以联想未来人工智能的高科技产品，选择八个主题中的一项进行创作。 展现形式可以借助语言表述、画图描述、编程设计、机器人作品、3D作品等元素中的一种或多种来表达自己的想法、展现自己的成果。 单个视频文件不超过200M。视频拍摄设备不限，以不低于1280*720分辨率、横画面进行拍摄并最终以MP4格式进行提交.',
          detail_url: 'http://www.aiaction-games.com/signup'
        }, {
          id: 'live004',
          title: '亲子游戏设计秀',
          imgUrl: require('../assets/web/game_4.png'),
          detail_button: '报名参加',
          detail_title: '我爱我家-亲子游戏设计秀活动',
          detail_content: '以“我爱我家”为主题，亲手创作一个独有的拼图游戏，送给爸爸妈妈或者家人，表达你对他们满满的爱，在拼图的过程中与他们一起回忆生活中的美好瞬间。制作时，挑选一张在日常生活中与爸爸妈妈或家人的合照，上传到Edbox平台，根据提示，完成创作，再分享给你的小伙伴们。这看似简单，却能够讲述你与父母家人之间的动人故事。',
          detail_url: 'https://edbox.101.com/news/07282020/232249789.shtml'
        }],
      gameListEn: [
        {
          id: 'live001',
          title: 'Knowing about AI',
          imgUrl: require('../assets/web/game_1.png'),
          detail_button: 'Sign Up',
          detail_title: 'Knowing about AI——AI Classroom Rules',
          detail_content: 'A question on artificial intelligence a day to lead you to the world of AI!<br>You may read the hints on the page of the questions to know more about relevant information. <br>Light up all the puzzles in 20 days. We are looking forward to your participation!',
          detail_url: 'http://ai.secsa.cn'
        }, {
          id: 'live002',
          title: 'Exploring AI',
          imgUrl: require('../assets/web/game_2.png'),
          detail_button: 'Experience',
          detail_title: 'Exploring AI——Tencent AI Experience Hall',
          detail_content: 'Tencent AI Experience Hall cooperates with Tencent AI Labs such as AI Lab, Tencent Youtu, WeChat Zhiling, etc., and displays cutting-edge AI technology with the lightest experience and the easiest interactive experiment to understand. The experiment involves algorithms such as image, natural language progression and machine learning, which provides classic cases for k12 students to learn artificial intelligence. ',
          detail_url: 'https://aiep.qcloud.com/#/aiExperience?iSchoolId=10372&iCloudToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJybHMiOiJzdHVkZW50IiwiYWlkIjoiMTAzNzIiLCJzaWQiOiIxMDAwMSIsInVpbiI6IjhkYVU3IiwiZXhwIjoxNTk3OTM5MjU0LCJpYXQiOjE1OTU0NzY0NTR9.jFMZEt1Q7EDT6AKJKIVjo3KnUSaSx_7npg4ZHFvai0U'
        }, {
          id: 'live003',
          title: 'Challenging AI',
          imgUrl: require('../assets/web/game_3.png'),
          detail_button: 'Sign Up',
          detail_title: 'Challenging AI——Micro video collection of “Our intelligent age AI challenge” Rules',
          detail_content: 'At each exhibition stand there is a rocket, and you may help it speed up with your “like” when you like that stand.competitors can look for AI products in our real life, or associate them with high-tech AI products in the future, and choose one of the eight themes for creation.One or more of the elements such as language expression, drawing description, programming design, robot works and 3D works can be used to express their ideas and show their achievements.A single video file is no more than 200m. Video capture equipment is not limited, with resolution no less than 1280 * 720 and horizontal screen, and finally submitted in MP4 format.',
          detail_url: 'http://www.aiaction-games.com/signup'
        }, {
          id: 'live004',
          title: 'Parent-child Game Design Show',
          imgUrl: require('../assets/web/game_4.png'),
          detail_button: 'Sign Up',
          detail_title: 'Parent-Child Game Design Show- I love my family Rules',
          detail_content: 'Create a unique jigsaw puzzle with the theme of "I love my family". Reminisce the beautiful moment of your lives together with your family while playing it. To start with, pick a daily family photo and upload it to Edbox. Follow the prompts to complete the creation and share it. Come and tell the moving story between you and your family!',
          detail_url: 'https://edbox.101.com/news/07282020/232249789.shtml'
        }]
    }
  },
  mounted() {
    let ids = {
      // 'h-001-hot-9': 'live001',
      // 'h-001-hot-10': 'live002',
      // 'h-001-hot-11': 'live003',
      // 'h-001-hor-12': 'live004',
      's-07-hot-3': 'live005',
      's-07-hot-4': 'live006',
      's-03-hot-4': 'live005',
      's-03-hot-5': 'live006',
    }
    if (this.hotspot) {
      this.detail = ids[this.hotspot]
    }
  },
  methods: {
    showDetail(item) {
      this.detail = item.id
    }
  }
}
</script>

<style scoped>
.content-area {
  margin-top: 5rem;
  width: 100%;
  min-height: 400px;
}
.page-title {
  text-align: center;
  color: #343434;
  padding-top: 3rem;
  padding-bottom: 3rem;
  font-size: 2.5rem;
}
.m-page-title {
  font-size: 16px;
}
.list-wrapper {
  width: 120rem;
  margin: 0 auto;
  font-size: 0px;
}
.m-list-wrapper {
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  text-align: center;
}
.cart-item {
  width: 28rem;
  height: 34.5rem;
  display: inline-block;
  vertical-align: top;
  margin-right: 2rem;
  margin-bottom: 2.5rem;
  background-color: #ffffff;
}
.m-cart-item {
  width: 48%;
  height: 34.5rem;
  display: inline-block;
  vertical-align: top;
  margin-right: 1%;
  margin-left: 1%;
  margin-bottom: 2.5rem;
  background-color: #ffffff;
}
.img-wrapper {
  width: 100%;
  height: 18.5rem;
  text-align: center;
  line-height: 18.5rem;
  font-size: 0px;
  color: #ffffff;
  position: relative;
}
.img-wrapper img {
  width: 100%;
  height: 100%;
}
.info-area {
  width: 100%;
  height: 7.5rem;
  line-height: 1;
  padding-top: 2rem;
  font-size: 2rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
}
.m-cart-item .info-area {
  font-size: 14px;
}
.cart-button {
  width: 100%;
  text-align: center;
}
.cart-button span {
  cursor: pointer;
  padding: 0.8rem 4rem;
  border-radius: 2rem;
  font-size: 1.8rem;
  display: inline-block;
}
.m-cart-item .cart-button span {
  font-size: 14px;
  border-radius: 14px;
}
.activity-button span {
  color: #ec6000;
  border: 1px solid #ec6000;
}
.activity-button span:hover {
  background-color: #ec6000;
  color: #ffffff;
}
.button-wrapper {
  width: 120rem;
  margin: 0 auto;
  font-size: 0px;
  padding-bottom: 2rem;
}
.button-item-wrapper {
  width: 50%;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
.button-item {
  font-size: 16px;
  position: relative;
  padding-top: 2rem;
  padding-right: 6rem;
  padding-bottom: 2rem;
  padding-left: 10rem;
  border-radius: 3rem;
  width: 35rem;
  display: inline-block;
  color: #ffffff;
  cursor: pointer;
}
.bt-1 {
  background-color: #8fc31f;
}
.bt1-img {
  position: absolute;
  left: 3rem;
  bottom: 0px;
  height: 6rem;
  width: 3.5rem;
  background-image: url(../assets/web/rocket_button.png);
  background-size: 100% 100%;
}
.bt-2 {
  background-color: #f29b76;
}
.bt2-img {
  position: absolute;
  left: 3rem;
  bottom: 0px;
  height: 6rem;
  width: 5rem;
  background-image: url(../assets/web/eye_button.png);
  background-size: 100% 100%;
}
.m-button-wrapper {
  width: 100%;
}
.m-button-wrapper .button-item-wrapper {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.m-button-wrapper .button-item {
  width: 70%;
  border-radius: 6rem;
}
.m-button-wrapper .bt1-img {
  height: 12rem;
  width: 7rem;
}
.m-button-wrapper .bt2-img {
  height: 12rem;
  width: 10rem;
}
</style>